import AsyncStorage from '@react-native-async-storage/async-storage'

// types
import { InitializeCache } from '../types/globalTypes'
type UserOnBoarding = {
  essUserOnBoardingKey: number
  lastUpdated: Date
}

/**
 * Initialize Cache
 *
 * @returns Promise<InitializeCache>
 */
const initializeCache = async (): Promise<InitializeCache> => {
  const data = await AsyncStorage.getItem('@Initialize')

  return JSON.parse(data)
}

/**
 * Retrieve the most recent onboarding user
 *
 * @param userOnBoardings all user on boarding
 * @return The recent onboarding user
 */
const getMostRecentUserOnBoardings = (
  userOnBoardings: UserOnBoarding[]
): number => {
  return userOnBoardings.reduce(
    (prev: UserOnBoarding, curr: UserOnBoarding) => {
      if (!prev || curr.lastUpdated > prev.lastUpdated) return curr
      return prev
    }
  ).essUserOnBoardingKey
}

export { initializeCache, getMostRecentUserOnBoardings }
